module.exports = __webpack_public_path__ + "static/media/logo.44bbc6d1.png";